import { Navigation } from "./navigation";
import { Contact } from "./contact";
import JsonData from "../data/data.json";
import { useState, useEffect } from "react";

export const Calculadoras = () => {

  const handleSelect = (e) => {
    const route = e.target.value;
    if (route) {
      window.location.href = route;
    }
  };

  return (
    <>
      <Navigation />

      <div id="calculadoras" className="calculadoras-page">
        <div className="container">
          <div className="row align-items-start calculadoras-row justify-content-center">
            <div className="col-12 col-md-6 text-center">

              <h2 className="mb-4 mt-4">
                Calculadoras <span style={{ fontSize: "1.4rem" }}>⬇️</span>
              </h2>

              <select
                className="form-select form-select-lg text-center mb-5"
                defaultValue=""
                onChange={handleSelect}
              >
                <option value="" disabled>
                  Selecione uma calculadora
                </option>

                <option value="/calculadora-imc">
                  Calculadora IMC
                </option>

                <option value="/calculadora-fib4">
                  Calculadora FIB-4
                </option>

                {/*
                Futuras calculadoras:
                <option value="/calculadora-tmb">Calculadora TMB</option>
                <option value="/calculadora-gordura">Percentual de Gordura</option>
                */}
              </select>

            </div>
          </div>
        </div>
      </div>

      <Contact data={JsonData.Contact} />
    </>
  );
};